export default "__VITE_PUBLIC_ASSET__fa304d78__"